// extracted by mini-css-extract-plugin
export default {"Dropzone":"ImageDropzone_Dropzone__mOC+W","Container":"ImageDropzone_Container__2XBxH","Text":"ImageDropzone_Text__TiNYX","PreviewImage":"ImageDropzone_PreviewImage__d4Uvg"};